import React from "react";
import "./SalesPackageStyles.scss";
import classNames from "classnames";

interface Props {
    name: string;
}

export const EmptySalesPackage:React.FC<Props> = ({name, children}) => {
    const className = classNames({
        "sales-package": true
    });

    return (
        <div className={className}>
            <div className={'sales-package__name'}>
                <span>{name}</span>
            </div>

            <div className={'sales-package__options'}>
                {children}
            </div>
        </div>
    )
};